import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, thriweDiscoveryUrl } from '../../../../../Containers/Config';
import { GET_GAMIFICATION_LIST, GET_GAMIFICATION_LIST_SUCCESS, GET_GAMIFICATION_LIST_ERROR } from '../../../actionType';
import apiCall from '../../../apiCall';
import { Constant } from '../../../../../Containers/Helpers/constant';

function* getGamificationList({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${thriweDiscoveryUrl}/v1/admin/games${payload?.game_id ? '/' + payload?.game_id : ''}`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload.urlParams,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_GAMIFICATION_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_GAMIFICATION_LIST_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_GAMIFICATION_LIST_ERROR, payload: error });
  }
}

export function* watchgetGamificationList() {
  yield takeEvery(GET_GAMIFICATION_LIST, getGamificationList);
}

function* getGamificationListSaga() {
  yield all([fork(watchgetGamificationList)]);
}

export default getGamificationListSaga;
